import warning from '../../images/warning.png';
import '../../styles/Styles.css';

const ErrorComponent = () => {
    return (
        <div className="error-container recaptcha-container">
            <img src={warning} alt='warning-icon' className='captcha-warning-icon'/>
            <div className="error-message recaptcha-error">
                It appears that you are interacting with a bot. <br /> For further assistance, please contact support.
            </div>
        </div>
    )
}

export default ErrorComponent;